import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AnalyzeNettleie } from 'src/app/services/analyse/analyse.types';

@Component({
  selector: 'app-nettleie-advisory',
  standalone: true,
  imports: [CommonModule, IonicModule],
  template: `
    <ion-row>
      <ion-col>
        @if (!errorAnalyse) {
        <div class="flex items-center mt-3">
          <div>
            @if (nettleieStatus === 'DANGER_OF_INCREASE') {
            <ion-icon
              name="alert-circle-outline"
              class="text-red-500 text-[2rem] mx-3"
            ></ion-icon>
            } @if (nettleieStatus === 'REDUCTION_POSSIBLE_NEXT_MONTH') {
            <ion-icon
              name="help-circle-outline"
              class="text-blue-500 text-[2rem] mx-3"
            ></ion-icon>
            } @if (nettleieStatus === 'KEEP_CALM_AND_CARRY_ON_AS_USUAL') {
            <ion-icon
              name="checkmark-circle-outline"
              class="text-green-500 text-[2rem] mx-3"
            ></ion-icon>
            }
          </div>
          <div>
            <p class="m-0">
              Ditt trinn nå
              <strong
                >{{ analyzeNettleie.current_step.cost }} kr ({{
                  analyzeNettleie.current_step.limit
                }}-{{ analyzeNettleie.current_step.next_limit }} kWh)</strong
              >
            </p>
            <p class="m-0 text-blue-500 text-xl">
              <strong>
                @if (nettleieStatus === 'DANGER_OF_INCREASE') { Fare for økt
                nettleie } @if (nettleieStatus ===
                'REDUCTION_POSSIBLE_NEXT_MONTH') { Mulig reduksjon av nettleie }
                @if (nettleieStatus === 'KEEP_CALM_AND_CARRY_ON_AS_USUAL') { Du
                gjør det bare bra }
              </strong>
            </p>
          </div>
        </div>

        <div class="mx-3">
          @if (nettleieStatus === 'DANGER_OF_INCREASE') {
          <p>
            Du står i fare for å gå opp et trinn! For å ikke gå opp til neste
            trinn må du unngå å bruke
            <strong>{{ dangerValue.toFixed(2).replace('.', ',') }} kWh</strong>
            eller mer i løpet av én time.
          </p>
          <p>
            Unngår du dette vil du forhindre en økning på
            <strong>
              {{
                analyzeNettleie.next_step.cost -
                  analyzeNettleie.current_step.cost
              }}
              kr</strong
            >
            i nettleien.
          </p>
          } @if (nettleieStatus === 'REDUCTION_POSSIBLE_NEXT_MONTH') {
          <p class="">
            Du har mulighet til å redusere nettleien om du klarer å holde
            gjennomsnittet under
            <strong>{{ analyzeNettleie.current_step.limit }} kWh </strong>neste
            måned.
          </p>
          <p>
            Da kan du kan spare
            <strong>
              {{
                analyzeNettleie.current_step.cost -
                  analyzeNettleie.previous_step.cost
              }}
              kr</strong
            >
            på nettleien ved å ikke gå opp et trinn.
          </p>
          } @if (nettleieStatus === 'KEEP_CALM_AND_CARRY_ON_AS_USUAL') {
          <p class="">
            Du har et fornuftig strømforbruk og trenger ikke å gjøre noen grep
            for å unngå økte kostnader.
          </p>
          }
        </div>
        } @else {
        <p>Det skjedde en feil</p>
        }
      </ion-col>
    </ion-row>
  `
})
export class NettleieAdvisoryComponent {
  @Input() analyzeNettleie: AnalyzeNettleie;
  @Input() errorAnalyse: boolean;

  nettleieStatus: string;
  dangerValue: number;

  constructor() {}

  ngOnChanges() {
    this.nettleieStatus = this.analyzeNettleie.result;
    this.dangerValue =
      3 * this.analyzeNettleie.current_step.next_limit -
      this.analyzeNettleie.hours_high_three[0].kwh -
      this.analyzeNettleie.hours_high_three[1].kwh;
  }
}
